module.exports = __webpack_public_path__ + "img/WA.cfc41883.png";